<template>
  <div v-if="studentSieId">
    <page-header
      has-return
      :page="{
        icon: 'fas fa-car',
        title: 'Asistencia de Beca',
        routes: ['Inicio', 'Asistencia de Beca'],
      }"
    />

    <custom-error
      v-if="showMissingSocialSecurityNumberWarning"
      class="scholarship-attendance__ssn-warning"
      is-alert-mode
      message="Registra tu Número de Seguro Social para completar tu perfil y agilizar el proceso de pago de tu BECA de transportación."
      variant="warning"
    />         

    <scholarship-attendance-history :student-sie-id="Number(studentSieId)" />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import CustomError from 'custom-error';
import ScholarshipAttendanceHistory from '@/views/students/scholarship-attendance/components/ScholarshipAttendanceHistory.vue';
import { getSocialSecurityNumber } from '@/api/profile.api';

export default {
  name: 'ScholarshipAttendance',
  components: { PageHeader, CustomError, ScholarshipAttendanceHistory },
  props: { studentSieId: { type: [String, Number], default: null } },
  data: () => ({
    hasLoadedSocialSecurityNumber: false,
    socialSecurityNumber: null,
  }),
  computed: {
    showMissingSocialSecurityNumberWarning() {
      return (
        this.hasLoadedSocialSecurityNumber &&
        !String(this.socialSecurityNumber || '').trim()
      );
    },
  },
  async created() {
    await this.loadSocialSecurityNumber();
  },
  methods: {
    async loadSocialSecurityNumber() {
      try {
        const { data } = await getSocialSecurityNumber();
        this.socialSecurityNumber = data;
        this.hasLoadedSocialSecurityNumber = true;
      } catch {
        this.hasLoadedSocialSecurityNumber = false;
      }
    },
  },
};
</script>

<style scoped>
.scholarship-attendance__ssn-warning {
  margin-top: 0 !important; 
}
</style>
